import D3EDate from "../classes/D3EDate" ;
import MeetingDTO from "../models/MeetingDTO" ;
import MicroSoftAcc from "../models/MicroSoftAcc" ;
import Lead from "../models/Lead" ;
import WSReader from "../rocket/WSReader" ;
import MessageDispatch from "../rocket/MessageDispatch" ;
import { RPCConstants } from "../rocket/D3ETemplate" ;


  export default  class  LeadServiceClient {  public async readEmailsFromLead ( acc : MicroSoftAcc,lead : Lead ) : Promise<boolean> {
 let r :WSReader=( await MessageDispatch.get().rpcMessage(RPCConstants.LeadService,RPCConstants.LeadServiceReadEmailsFromLead,{ 'args':( w ) => {
 w.writeObjFull(acc);

w.writeObjFull(lead);
 }
 }));

let code :number=r.readByte();

if ( code === 1 ) {
 let error :string=r.readString();

return Promise.error(error) ; 
 }

return ( r.readBoolean() as boolean ) ; 
 }
  public async createLink ( acc : MicroSoftAcc ) : Promise<string> {
 let r :WSReader=( await MessageDispatch.get().rpcMessage(RPCConstants.LeadService,RPCConstants.LeadServiceCreateLink,{ 'args':( w ) => {
 w.writeObjFull(acc);
 }
 }));

let code :number=r.readByte();

if ( code === 1 ) {
 let error :string=r.readString();

return Promise.error(error) ; 
 }

return ( r.readString() as string ) ; 
 }
  public async refreshAccessToken ( acc : MicroSoftAcc ) : Promise<boolean> {
 let r :WSReader=( await MessageDispatch.get().rpcMessage(RPCConstants.LeadService,RPCConstants.LeadServiceRefreshAccessToken,{ 'args':( w ) => {
 w.writeObjFull(acc);
 }
 }));

let code :number=r.readByte();

if ( code === 1 ) {
 let error :string=r.readString();

return Promise.error(error) ; 
 }

return ( r.readBoolean() as boolean ) ; 
 }
  public async fetchAppMeetings ( acc : MicroSoftAcc ) : Promise<Array<MeetingDTO>> {
 let r :WSReader=( await MessageDispatch.get().rpcMessage(RPCConstants.LeadService,RPCConstants.LeadServiceFetchAppMeetings,{ 'args':( w ) => {
 w.writeObjFull(acc);
 }
 }));

let code :number=r.readByte();

if ( code === 1 ) {
 let error :string=r.readString();

return Promise.error(error) ; 
 }

return ( r.readRefList() as Array<MeetingDTO> ) ; 
 }
  public async cancelMeeting ( acc : MicroSoftAcc,eventId : string ) : Promise<boolean> {
 let r :WSReader=( await MessageDispatch.get().rpcMessage(RPCConstants.LeadService,RPCConstants.LeadServiceCancelMeeting,{ 'args':( w ) => {
 w.writeObjFull(acc);

w.writeString(eventId);
 }
 }));

let code :number=r.readByte();

if ( code === 1 ) {
 let error :string=r.readString();

return Promise.error(error) ; 
 }

return ( r.readBoolean() as boolean ) ; 
 }
  public async updateMeeting ( acc : MicroSoftAcc,eventId : string,subject : string,startTime : D3EDate,endTime : D3EDate,timeZone : string ) : Promise<boolean> {
 let r :WSReader=( await MessageDispatch.get().rpcMessage(RPCConstants.LeadService,RPCConstants.LeadServiceUpdateMeeting,{ 'args':( w ) => {
 w.writeObjFull(acc);

w.writeString(eventId);

w.writeString(subject);

w.writeDate(startTime);

w.writeDate(endTime);

w.writeString(timeZone);
 }
 }));

let code :number=r.readByte();

if ( code === 1 ) {
 let error :string=r.readString();

return Promise.error(error) ; 
 }

return ( r.readBoolean() as boolean ) ; 
 }
  public async createTeamsMeeting ( acc : MicroSoftAcc,subject : string,startTime : D3EDate,endTime : D3EDate,timeZone : string,attendees : Array<string> ) : Promise<string> {
 let r :WSReader=( await MessageDispatch.get().rpcMessage(RPCConstants.LeadService,RPCConstants.LeadServiceCreateTeamsMeeting,{ 'args':( w ) => {
 w.writeObjFull(acc);

w.writeString(subject);

w.writeDate(startTime);

w.writeDate(endTime);

w.writeString(timeZone);

w.writeStringList(attendees);
 }
 }));

let code :number=r.readByte();

if ( code === 1 ) {
 let error :string=r.readString();

return Promise.error(error) ; 
 }

return ( r.readString() as string ) ; 
 }
 }